'use client';

import { useSuspenseQuery } from '@tanstack/react-query';
import React from 'react';

import { COMMENT_TYPE } from '@/api';
import { getCommentList } from '@/api/getCommentList';
import { CommentThread } from '@/app/_components/Comment/CommentThread';

import { HometownNewsCommentActions } from './HometownNewsCommentActions';

interface CommentListProps {
  id: number;
  title: string;
}

export const CommentList = ({ title, id }: CommentListProps) => {
  const initialComment = useSuspenseQuery({
    queryKey: ['getCommentList', id],
    queryFn: async () =>
      await getCommentList({
        commentType: COMMENT_TYPE.HOMETOWN_NEWS,
        id,
      }),
  });

  const initialCommentData = initialComment.data;

  return (
    <CommentThread
      commentType={COMMENT_TYPE.HOMETOWN_NEWS}
      contentId={id}
      title={title}
      initialData={initialCommentData}
      commentFieldProps={{
        withPortal: false,
        sticky: true,
        topSlot: <HometownNewsCommentActions contentId={id} title={title} />,
      }}
    />
  );
};
